import React, { useEffect, useRef } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledAboutSection = styled.section`
  max-width: 900px;

  .inner {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-gap: 50px;

    @media (max-width: 768px) {
      display: block;
    }
  }
`;
const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-template-columns: repeat(4, minmax(140px, 200px));
    grid-gap: 0 10px;
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
const StyledPic = styled.div`
  position: relative;
  max-width: 300px;

  @media (max-width: 768px) {
    margin: 50px auto 0;
    width: 70%;
  }

  .wrapper {
    ${({ theme }) => theme.mixins.boxShadow};
    display: block;
    position: relative;
    width: 100%;
    border-radius: var(--border-radius);
    background-color: var(--green);

    &:hover,
    &:focus {
      outline: 0;

      &:after {
        top: 15px;
        left: 15px;
      }

      .img {
        filter: none;
        mix-blend-mode: normal;
      }
    }

    .img {
      position: relative;
      border-radius: var(--border-radius);
      // the green hue
      // mix-blend-mode: multiply;
      // filter: grayscale(100%) contrast(1);
      // transition: var(--transition);
    }

    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: var(--border-radius);
      transition: var(--transition);
    }

    &:before {
      top: 0;
      left: 0;
      background-color: var(--navy);
      mix-blend-mode: screen;
    }

    &:after {
      border: 2px solid var(--green);
      top: 20px;
      left: 20px;
      z-index: -1;
    }
  }
`;

const About = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  const skills = [
    'C#',
    '.Net',
    'Java',
    'Spring Boot',
    'Quarkus',
    'C++',
    'GO',
    'Python',
    'FastAPI',
    'Dart',
    'Flutter',
    'Angular',
    'React',
    'NextJs',
    'Remix',
    'Node.js',
    'MongoDB',
    'PostgreSQL',
    'GitHub Actions',
    'Docker',
    'Kubernetes',
  ];

  return (
    <StyledAboutSection id="about" ref={revealContainer}>
      <h2 className="numbered-heading">About Me</h2>

      <div className="inner">
        <StyledText>
          <div>
            <p>
              Hello! My name is Minhaz and I enjoy learning and creating new things. My main
              interest in problem solving, be it whether fixing the microwave at my house or
              creating an add-on for firefox, chrome, edge and opera just on a whim. My interest in
              things like this began very early when playing GTA Vice city and changing vehicle
              speed,weight etc by editing a text file. After that my interest peaked when I wanted
              to automate some things in websites that I use. I learned javascript for it and used
              Greasemonkey to execute automated scripts in difference pages.
            </p>

            <p>
              Fast-forward to today, and I’ve had the privilege of working at{' '}
              <a href="https://selisegroup.com/" target="_blank">
                SELISE AG
              </a>
              , one of the most prestigious tech company in the country based on Switzerland,{' '}
              <a href="https://asthait.com/" target="_blank">
                AsthaIt
              </a>
              , a USA based software solutions company,{' '}
              <a href="https://smartdatasoft.com/" target="_blank">
                Smart data soft
              </a>
              , a marketplace based solutions company.{' '}
            </p>

            <p>
              I also try to write some blogs{' '}
              <a href="https://medium.com/@minhaz1217" target="_blank">
                medium
              </a>{' '}
              and{' '}
              <a href="https://dev.to/minhaz1217" target="_blank">
                dev.to
              </a>{' '}
              and document some of the interesting things that I learn during my regular tinkering.
            </p>

            <p>Here are a few technologies I’ve been working with recently:</p>
          </div>

          <ul className="skills-list">
            {skills && skills.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>
        </StyledText>

        <StyledPic>
          <div className="wrapper">
            <StaticImage
              className="img"
              src="../../images/me.jpg"
              width={500}
              quality={95}
              formats={['AUTO', 'WEBP', 'AVIF']}
              alt="Headshot"
            />
          </div>
        </StyledPic>
      </div>
    </StyledAboutSection>
  );
};

export default About;
